import { c as _c } from "react/compiler-runtime";
import { Center } from '@chakra-ui/react';
import SearchInvestorsAnim from '@src/components/sco/Animations/InvestorMatch/SearchInvestorsAnim';
import { ContentSection } from '@src/components/sco/LayoutBlocks/ContentSection';
import React from 'react';
export const FindInvestorsContent = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      title: "Get My Investor Matches",
      href: "/investors/matching/start",
      variant: "cta"
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ContentSection componentPlacement="right" description="Tell us a bit about your startup and we'll do all the heavy lifting to find the most qualified investors for your deal. No more clunky database searches or sketchy investor lists." title="Stop guessing! We find the best investors for you." buttons={t0} component={<Center width="full"><SearchInvestorsAnim /></Center>} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};